<template>
  <div class="flex-1 flex flex-col">
    <div class="w-full p-24 overflow-y-auto min-w-0 flex flex-col">
      <div class="text-headline-3 q-mb-sm">
        {{ t('selectMaturityLevel') }}
      </div>
      <div class="flex gap-12">
        <button
          v-for="(alt, i) in alternativas"
          :key="i"
          type="button"
          :class="
            currentIndex === i + 1
              ? 'border-primary-pure bg-primary-pure/10'
              : 'border-neutral-100/10'
          "
          class="w-[89px] h-full p-10 pt-16 rounded-md border transition-all duration-300 hover:scale-105 hover:border-primary-pure"
          @click="currentIndex = i + 1"
        >
          <div
            class="size-full relative grid place-items-center z-10"
          >
            <span
              class="w-full h-64 absolute -top-[.375rem] rounded-[1.5px]"
              :class="
                currentIndex === i + 1
                  ? 'bg-primary-pure/15'
                  : 'bg-card-400'
              "
            />
            <div
              class="relative z-10 shadow-[0_0_6.207px_0_rgba(75,75,89,0.30)]"
            >
              <IconCardNivel
                class="rounded-[3px] ring-1 ring-transparent"
                :class="{
                  '!ring-primary-pure': currentIndex === i + 1,
                }"
              />
              <p
                class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 text-title-3 !font-bold text-neutral-60"
              >
                {{ i + 1 }}
              </p>
            </div>
          </div>
        </button>
      </div>

      <TabFormAlternativa
        v-for="alt in alternativas"
        v-show="alternativas.indexOf(alt) + 1 === currentIndex"
        :ref="(el) => (alternativaRefs[alt.id] = el)"
        :key="alt.id"
        :alternativa="alt"
        @update:modelValue="emit('change:alternativas', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import IconCardNivel from 'public/icons/card_nivel.svg'
import TabFormAlternativa from 'components/Tabs/TabFormAlternativa.vue'

const { t } = useI18n()

const props = defineProps({
  initialNiveis: { type: Array, required: true },
})

const currentIndex = ref(1)
const alternativas = ref([...props.initialNiveis])
const alternativaRefs = reactive({})

const validate = async () => {
  const refs = Object.values(alternativaRefs)
  if (refs.length === 0) return true

  const results = await Promise.all(
    refs.map((ref) => ref?.validate?.())
  )
  return results.every((r) => r === true)
}

const emit = defineEmits(['change:alternativas'])

defineExpose({ validate })
</script>
